import { sendDelete, sendGet, sendPost, sendPut } from './axios';

export const getProfile = () => sendGet(`/user/profile`);

export const getListProfile = (payload) =>
  sendPost(`/user/list-profile?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`);

export const updateProfile = (payload) => sendPut(`/user/update-profile`, payload);

export const updateLastLogin = () => sendPut(`/user/update-last-login`);

export const getBlock = () => sendGet(`/user/block/list?type=2`);

export const getBlockOneSide = (userId) => sendGet(`/get-block/${userId}`);

export const unBlock = (userId) => sendDelete(`/unblock/${userId}`);

export const updatePhone = (payload) => sendPut(`/user/change-phone`, payload);

export const updateEmail = (payload) => sendPut(`/user/change-email`, payload);

export const createVerifyEmail = (payload) => sendPut(`/create-verify`, payload);

export const getVerifyEmail = (userId) => sendGet(`/verify-email/${userId}`);

export const updateLoginType = (payload) => sendPut(`/user/change-login-type`, payload);

export const verifyCodePhone = (payload) => sendPut(`/user/verify-change-phone`, payload);

export const updateNotification = (payload) => sendPut(`/user/setting-notification`, payload);

export const updateCallForward = (payload) => sendPut(`/user/setting-call-forward`, payload);

export const getListLikeFromTarget = (payload) => sendGet(`/user/like/list`, payload);

export const getListLikeFromMe = () => sendGet(`/likes`);

export const createLike = (payload) => sendPost(`/like`, payload);

export const getConversation = (targetId) => sendGet(`/conversation/user/${targetId}`);

export const readAllMessageUnRead = (payload) => sendGet(`/chat/${payload.idConversation}`);

export const getListFootpirntFromTarget = () => sendGet(`/users/footprints`);

export const getListFootprintFromMe = () => sendGet(`/footprints`);

export const checkIsPhoneExist = (phoneNumber) => sendGet(`/user/check-exist-phone/${phoneNumber}`);

export const checkIsEmailExist = (email) => sendGet(`/user/check-exist-email/${email}`);

export const readAllChatSupportMessage = (chatRoomId) => sendGet(`/chat-support/read/${chatRoomId}`);

export const readAllChatAgentMessage = (chatRoomId) => sendGet(`/chat-agent/read/${chatRoomId}`);

export const checkStatusEmailSendGrid = (payload) => sendPost(`/check-email`, payload);

